/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdatePluginServerForm,
  UpdatePluginServerForm$Outbound,
  UpdatePluginServerForm$outboundSchema,
} from "../components/updatepluginserverform.js";

export type UpdatePluginServerSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type UpdatePluginServerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updatePluginServerForm: UpdatePluginServerForm;
};

/** @internal */
export type UpdatePluginServerSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdatePluginServerSecurity$outboundSchema: z.ZodMiniType<
  UpdatePluginServerSecurity$Outbound,
  UpdatePluginServerSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updatePluginServerSecurityToJSON(
  updatePluginServerSecurity: UpdatePluginServerSecurity,
): string {
  return JSON.stringify(
    UpdatePluginServerSecurity$outboundSchema.parse(updatePluginServerSecurity),
  );
}

/** @internal */
export type UpdatePluginServerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdatePluginServerForm: UpdatePluginServerForm$Outbound;
};

/** @internal */
export const UpdatePluginServerRequest$outboundSchema: z.ZodMiniType<
  UpdatePluginServerRequest$Outbound,
  UpdatePluginServerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updatePluginServerForm: UpdatePluginServerForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      updatePluginServerForm: "UpdatePluginServerForm",
    });
  }),
);

export function updatePluginServerRequestToJSON(
  updatePluginServerRequest: UpdatePluginServerRequest,
): string {
  return JSON.stringify(
    UpdatePluginServerRequest$outboundSchema.parse(updatePluginServerRequest),
  );
}
